import { sendPasswordResetEmail } from 'firebase/auth';
import { toast } from 'react-toastify';

import { auth } from '../../';

export const forgotPassword = async (email, navigate) => {
  try {
    if (email === '') {
      toast.error('Please enter your email address.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
      return;
    }
    await sendPasswordResetEmail(auth, email);
    navigate('/login');
  } catch (error) {
    console.error(error);
  }
};
